import { useEffect, useState } from "react";
import "../../styles/modal.css";
import { resolveMediaCarBrand } from "../../services/api";

export default function OrderTypeEditModal({ open, ordertype, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    description: "",
  });

  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (ordertype) {
      setForm({
        name: ordertype.name || "",
        description: ordertype.description || "",
      });

     
      if (ordertype.logo) {
        setPreview(resolveMediaCarBrand(ordertype.logo));
      }
    }
  }, [ordertype]);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open || !ordertype) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      setForm({ ...form, logo: file });
      setPreview(URL.createObjectURL(file));
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = new FormData();
    data.append("name", form.name);
 
    if (form.logo) {
      data.append("logo", form.logo);
    }

    onSubmit(ordertype.id, data);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Modifier le type de commande</h3>

        <form onSubmit={handleSubmit} className="modalForm">
          <div className="formGrid">
            <Input
              label="Nom du type de commande"
              name="name"
              value={form.name}
              required
              onChange={handleChange}
            />
              <Input
              label="Description du type de commande"
              name="description"
              value={form.description}
              required
              onChange={handleChange}
            />

            {/* <FileInput
              label="Logo"
              preview={preview}
              onChange={handleFileChange}
            /> */}
          </div>

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">Mettre à jour</button>
          </div>
        </form>
      </div>
    </div>
  );
}

 

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}

function FileInput({ label, preview, onChange }) {
  return (
    <div className="fileUpload">
      <label className="fileLabel">{label}</label>

      <label className="fileDrop">
        {preview ? (
          <img src={preview} alt="preview" className="filePreview" />
        ) : (
          <div className="filePlaceholder">
            <span className="fileIcon">📷</span>
            <span>Cliquer pour changer</span>
            <small>PNG, JPG</small>
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={onChange}
          hidden
        />
      </label>
    </div>
  );
}
